export enum SubDomain {
    ADMIN = 'admins',
    OFFICE = 'office',
}
